import { __assign } from "tslib";
import clsx from 'clsx';
import React from 'react';
import styles from './styles.css.js';
export function DarkHeader(_a) {
    var isMobile = _a.isMobile, isRefresh = _a.isRefresh, children = _a.children, toolsWidth = _a.toolsWidth, navigationWidth = _a.navigationWidth, topOffset = _a.topOffset, sticky = _a.sticky;
    var refreshStyles = isRefresh && !isMobile
        ? {
            paddingLeft: navigationWidth,
            marginLeft: -1 * navigationWidth,
            paddingRight: toolsWidth,
            marginRight: -1 * toolsWidth
        }
        : {};
    return (React.createElement("div", { className: clsx(styles['content-header'], sticky && styles['content-header-sticky'], isRefresh && 'awsui-context-content-header', isRefresh && styles['content-header-refresh']), style: __assign(__assign({}, refreshStyles), { top: topOffset }) }, children));
}
